const mainImageImgArea = document.querySelector('#main-img-area img');
const mainImageLinkArea = document.querySelector('#main-img-area a');
const subImageImgs = document.querySelectorAll('.sub-img-area img');

if(mainImageImgArea && subImageImgs){
    subImageImgs.forEach(elem => {
        elem.addEventListener('mouseenter', e => {
            console.log(e.currentTarget.src)
            mainImageImgArea.src = e.currentTarget.src;
          mainImageLinkArea.href = e.currentTarget.src;
            mainImageImgArea.srcset = e.currentTarget.srcset;
        });
    });
}